import { render } from "./VideoHome.vue?vue&type=template&id=29695b2d"
import script from "./VideoHome.vue?vue&type=script&lang=js"
export * from "./VideoHome.vue?vue&type=script&lang=js"

import "./VideoHome.vue?vue&type=style&index=0&id=29695b2d&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__